import './index.scss';

import React, { useEffect, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useSWR from 'swr';

import axios from '../../admin-axios';
import { detectError } from '../../utils';
import LongPaginationHandler from '../LongPaginationHandler';

const fetcher = (url) => axios.get(url).then((res) => res.data);
const CustomersPaymentHistory = () => {
  const { customer_id, first, last } = useParams();
  const [page, setPage] = useState(1);
  const [tableView, setTableView] = useState('normal');
  const [filterResult, setFilterResult] = useState([]);
  const [filterLoading, setFilterLoading] = useState(false);
  const [filterPage, setFilterPage] = useState(1);
  const [filterTotal, setFilterTotal] = useState(0);
  const [filterPerPage, setFilterPerPage] = useState(20);
  const [filterError, setFilterError] = useState('');

  const dateRef = useRef(null);

  const {
    user: { stationId }
  } = useSelector((state) => state.auth);

  const { data, error, isLoading } = useSWR(
    `/account/statements/${customer_id}/${stationId}?page=${page}`,
    fetcher
  );

  const paginate = (pageNumber) => {
    setPage(pageNumber);
  };

  const paginateFilter = (pageNumber) => {
    setFilterPage(pageNumber);
  };

  const filterByDateHandler = async () => {
    if (!dateRef.current.value) {
      toast.error('Please choose a date to filter by');
      return;
    }
    const toSend = {
      date: dateRef.current.value
    };

    try {
      setFilterLoading(true);
      setTableView('filtering');
      const res = await axios.post(`account/statements/filter/${customer_id}/${stationId}`, toSend);
      setFilterResult(res.data.data.data);
      setFilterPage(res.data.data.current_page);
      setFilterTotal(res.data.data.total);
      setFilterPerPage(res.data.data.per_page);
      setFilterLoading(false);
    } catch (e) {
      setFilterError(detectError(e));
      setFilterLoading(false);
    }
  };

  useEffect(() => {
    if (filterPage && dateRef.current?.value) {
      filterByDateHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterPage]);

  useEffect(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="customers_ph">
      <div className="row g-2 mb-5">
        <div className="col-xl-6">
          <div className="row g-2">
            <div className="col-md-6">
              <div className="customers_ph_title">Account Statement</div>
            </div>
            <div className="col-md-6 customers_ph_name">{`${first} ${last}`}</div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="row g-2">
            <div className="offset-xl-2 col-xl-4 col-md-6">
              <input
                type="date"
                name="filter_date"
                ref={dateRef}
                placeholder="Choose Filter Date"
                className="form-control customers_ph_input w-100"
              />
            </div>
            <div className="col-md-6">
              <button
                onClick={filterByDateHandler}
                className="btn customers_ph_button w-100"
                type="button">
                Apply Filter
              </button>
            </div>
          </div>
        </div>
      </div>
      {tableView === 'filtering' && (
        <div className="">
          <button
            onClick={() => setTableView('normal')}
            type="button"
            className="mb-3 btn unapproved_transactions_general_button">
            Back to All Statements
          </button>
        </div>
      )}
      <div className="customers_ph_table_wrapper">
        <table className="table customers_ph_table">
          <thead>
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Time</th>
              <th scope="col">Payment ID</th>
              <th scope="col">Amount Paid</th>
              {/* <th scope="col">Payment Type</th> */}
            </tr>
          </thead>
          {tableView === 'normal' && (
            <tbody>
              {/* eslint-disable-next-line no-nested-ternary */}
              {error && (
                <tr className="py-3">
                  <td colSpan={4}>
                    <div className="d-flex justify-content-center w-100">{detectError(error)}</div>
                  </td>
                </tr>
              )}
              {/* eslint-disable-next-line no-nested-ternary */}
              {isLoading && (
                <tr className="py-3">
                  <td colSpan={4}>
                    <div className="d-flex justify-content-center w-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  </td>
                </tr>
              )}
              {!isLoading && !error && data.message && (
                <tr>
                  <td colSpan={4} className="w-100 text-center">
                    {data.message}
                  </td>
                </tr>
              )}
              {!isLoading &&
                !error &&
                data?.data?.data &&
                data?.data?.data.length > 0 &&
                data.data.data.map((ph, index) => (
                  <tr key={index}>
                    <td>{new Date(ph.date_payment).toDateString()}</td>
                    <td>{new Date(ph.date_payment).toLocaleTimeString()}</td>
                    <td>{ph.payment_id}</td>
                    <td>
                      {data.currency} {ph.amount}
                    </td>
                    {/* <td>{ph.payment_type}</td> */}
                  </tr>
                ))}
              {!isLoading && !error && data?.data?.data && data?.data?.data.length === 0 && (
                <tr>
                  <td colSpan={4} className="w-100 text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          )}
          {tableView === 'filtering' && (
            <tbody>
              {/* eslint-disable-next-line no-nested-ternary */}
              {filterError && (
                <tr className="py-3">
                  <td colSpan={4}>
                    <div className="d-flex justify-content-center w-100">{filterError}</div>
                  </td>
                </tr>
              )}
              {/* eslint-disable-next-line no-nested-ternary */}
              {filterLoading && (
                <tr className="py-3">
                  <td colSpan={4}>
                    <div className="d-flex justify-content-center w-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  </td>
                </tr>
              )}
              {!filterError &&
                !filterLoading &&
                filterResult &&
                filterResult.length > 0 &&
                filterResult.map((ph, index) => (
                  <tr key={index}>
                    <td>{new Date(ph.date_payment).toDateString()}</td>
                    <td>{new Date(ph.date_payment).toLocaleTimeString()}</td>
                    <td>{ph.payment_id}</td>
                    <td>
                      {data.currency} {ph.amount}
                    </td>
                    {/* <td>{ph.payment_type}</td> */}
                  </tr>
                ))}
              {!filterLoading && !filterError && filterResult && filterResult.length === 0 && (
                <tr>
                  <td colSpan={4} className="w-100 text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </table>
      </div>
      {tableView === 'normal' && data && !data.message && (
        <LongPaginationHandler
          elementsPerPage={data?.data?.per_page}
          totalElements={data?.data?.total}
          activePage={page}
          paginate={paginate}
        />
      )}
      {tableView === 'filtering' && filterResult && (
        <LongPaginationHandler
          elementsPerPage={filterPerPage}
          totalElements={filterTotal}
          activePage={filterPage}
          paginate={paginateFilter}
        />
      )}
    </div>
  );
};

export default CustomersPaymentHistory;
